var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('promoted-landlord-data-table'),_c('side-drawer',[_c('template',{slot:"formDetails"},[_c('create-promotion')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }